import styled from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import { Marquee } from 'atoms/container/Marquee';
import { Horizontal } from 'atoms/layout/flex';

import christmas_limited from './assets/christmas/limited.jpg';
import christmas_rare from './assets/christmas/rare.jpg';
import christmas_super_rare from './assets/christmas/super_rare.jpg';
import christmas_unique from './assets/christmas/unique.jpg';
import common from './assets/common.jpg';
import custom_series from './assets/custom_series.jpg';
import limited from './assets/limited.jpg';
import playoffs_limited from './assets/playoffs-24/limited.jpg';
import playoffs_rare from './assets/playoffs-24/rare.jpg';
import playoffs_super_rare from './assets/playoffs-24/super_rare.jpg';
import playoffs_unique from './assets/playoffs-24/unique.jpg';
import rare from './assets/rare.jpg';
import super_rare from './assets/super_rare.jpg';
import unique from './assets/unique.jpg';

const BackgroundContainer = styled(Horizontal)`
  position: absolute;
  inset: 0;
  display: flex;
  z-index: -1;
`;

const Gradient = styled.div`
  width: 450px;
  max-width: 100%;
  background-size: 100%;
  height: 100%;
`;

type Assets = Record<Rarity, string>;

const christmasAssets: Assets = {
  [Rarity.common]: common,
  [Rarity.custom_series]: custom_series,
  [Rarity.limited]: christmas_limited,
  [Rarity.rare]: christmas_rare,
  [Rarity.super_rare]: christmas_super_rare,
  [Rarity.unique]: christmas_unique,
};

const classic_assets: Assets = {
  [Rarity.common]: common,
  [Rarity.custom_series]: custom_series,
  [Rarity.limited]: limited,
  [Rarity.rare]: rare,
  [Rarity.super_rare]: super_rare,
  [Rarity.unique]: unique,
};

const playoffs_24_assets: Assets = {
  [Rarity.common]: common,
  [Rarity.custom_series]: custom_series,
  [Rarity.limited]: playoffs_limited,
  [Rarity.rare]: playoffs_rare,
  [Rarity.super_rare]: playoffs_super_rare,
  [Rarity.unique]: playoffs_unique,
};

type Background = {
  assets: Assets;
  duration: string;
  style?: React.CSSProperties;
};

const PLAYOFFS_24_VALUES = ['Postseason™', 'ace'];

const getBackgroundFromEditionName = (
  editionName?: string | null
): Background => {
  if (editionName) {
    if (editionName?.startsWith('neon_christmas')) {
      return {
        assets: christmasAssets,
        duration: '50s',
        style: {
          width: '900px',
        },
      };
    }
    if (PLAYOFFS_24_VALUES.includes(editionName)) {
      return {
        assets: playoffs_24_assets,
        duration: '25s',
      };
    }
  }
  return { assets: classic_assets, duration: '25s' };
};

type Props = {
  rarity: Rarity;
  editionName?: string | null;
};

export const ScarcityBackground = ({ rarity, editionName }: Props) => {
  const { assets, duration, style } = getBackgroundFromEditionName(editionName);
  return (
    <BackgroundContainer>
      <Marquee direction="reverse" gap={0} duration={duration} stretch>
        <Gradient
          style={{
            backgroundImage: `url(${assets[rarity]})`,
            ...style,
          }}
        />
      </Marquee>
    </BackgroundContainer>
  );
};
